<template>
  <v-card-text>
    <v-row>
      <v-col>
        <OdocCaseTypesInput :readonly="readonly" :case-types="caseTypes" />
        <OdocEventDateInput :readonly="readonly" />
        <OdocTitleInput :readonly="readonly" />
        <OdocDescriptionInput :readonly="readonly" />
        <OdocOperatorBeroendeInput :readonly="readonly" />
      </v-col>
      <v-col>
        <OdocLocationsInput :readonly="readonly" :locations="locations" />
        <OdocTrainNumberInput :readonly="readonly" />
        <OdocRoutesInput :readonly="readonly" />
        <OdocPrognosInput :readonly="readonly" />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import OdocTitleInput from './OdocTitleInput'
import OdocLocationsInput from './OdocLocationsInput'
import OdocCaseTypesInput from './OdocCaseTypesInput'
import OdocDescriptionInput from './OdocDescriptionInput'
import OdocOperatorBeroendeInput from './OdocOperatorBeroendeInput'
import OdocEventDateInput from './OdocEventDateInput'
import OdocPrognosInput from './OdocPrognosInput'
import OdocTrainNumberInput from './OdocTrainNumberInput'
import OdocRoutesInput from './OdocRoutesInput'

export default {
  name: 'OdocForm',

  props: {
    locations: Array,
    caseTypes: Array,
    readonly: Boolean
  },

  components: {
    OdocTitleInput,
    OdocLocationsInput,
    OdocCaseTypesInput,
    OdocDescriptionInput,
    OdocOperatorBeroendeInput,
    OdocEventDateInput,
    OdocPrognosInput,
    OdocTrainNumberInput,
    OdocRoutesInput
  }
}
</script>
